import { Excel, Pdf, Placeholder, Txt, Word, Ppt, Zip, Rar, Csv, 
  Audio1, Video, Contact, Image } from 'assets/images';

export function getExtension(name = '') {
    if (!name) return '';
    const lastDot = name.substring(name.lastIndexOf('.') + 1, name.length);
    return '.' + lastDot;
}
const getFile = (fileType, extension) => {
  const getLowercase = extension ? extension.toString().toLowerCase() : '';
  if (getLowercase === '.doc' || getLowercase === '.docx' || fileType === 'application/msword') {
    return Word;
  } else if (getLowercase === '.xls' || getLowercase === '.xlsx' || fileType === 'application/vnd.ms-excel') {
    return Excel;
  } else if (getLowercase === '.txt' || fileType === 'text/plain') {
    return Txt;
  } else if (getLowercase === '.pdf' || fileType === 'application/pdf') {
    return Pdf;
  } else if (getLowercase === '.csv' || fileType === 'application/csv') {
    return Csv;
  } else if (
    getLowercase === '.ppt' ||
    getLowercase === '.pptx' ||
    fileType === 'application/ppt' ||
    fileType === 'application/pptx'
  ) {
    return Ppt;
  } else if (getLowercase === '.zip' || fileType === 'application/zip' || fileType === 'application/x-zip-compressed') {
    return Zip;
  } else if (getLowercase === '.rar' || fileType === 'application/rar' || fileType === 'application/vnd.rar') {
    return Rar;
  } else {
    return Placeholder;
  }
};
const placeholderForAttahments = {
  'image':Image,
  'video':Video,
  'audio':Audio1,
  'contact':Contact
}

export const getFileFromType = (fileType, extension, messageType = null) => {
  if([ 'image','video','audio','contact' ].indexOf(messageType) > -1) {
    return placeholderForAttahments [ messageType ] || Placeholder
  }
  return getFile(fileType, extension);
};

export function formatBytes(a, b = 2) { 
    if (0 === a) 
    {return '0 Bytes'}
    const c = 0 > b ? 0 : b, d = Math.floor(Math.log(a) / Math.log(1024));
    return parseFloat((a / Math.pow(1024, d)).toFixed(c)) + ' ' + [ 'Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB' ][ d ]
}
